import { Component, OnInit, Input } from '@angular/core';
import moment from 'moment-timezone';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-non-referee-card',
  templateUrl: './non-referee-card.component.pug',
  styleUrls: ['./non-referee-card.component.scss'],
  standalone: false
})
export class NonRefereeCardComponent implements OnInit {
  @Input() gap: any;
  @Input() workHistoryStart: any;
  @Input() workHistoryEnd: any;
  coverageStart: any;
  coverageEnd: any;
  coverageOffset:any;
  coverageWidth:any;

  constructor(private permissions: PermissionsService) { }

  ngOnInit(): void {
    const whStart = this.format_date(this.workHistoryStart);
    const whEnd = this.format_date(this.workHistoryEnd);
    this.coverageStart = this.format_date(this.gap['start_date']);
    this.coverageEnd = this.format_date(this.gap['end_date']);
    const fullWidth = this.calculateDifference(whStart,whEnd);
    const width = this.calculateDifference(this.coverageStart,this.coverageEnd);
    const leftOffset = this.calculateDifference(whStart,this.coverageStart);
    this.coverageWidth = ''+String(width/fullWidth * 100)+'%';
    this.coverageOffset = ''+String(leftOffset/fullWidth * 100)+'%';
  }

  format_date(date_dict: any) {
    return moment(date_dict.year+'-'+ date_dict.month +'-'+ date_dict.day, "YYYY-MM-DD").format('DD MMM YYYY');
  }

  calculateDifference(startDate, endDate) {
    var start = new Date(startDate);
    var end = new Date(endDate);
    return Math.floor((end.getTime() - start.getTime()) / 1000 / 60 / 60 / 24);
  }

}
